import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class DatiOrdinePRModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack',
        '$uibModal',
        'configuration',
        '$sce'
    ];

    private close: any;
    private settings: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private configuration: any,
        private $sce: ng.ISCEService
    ) {

        // dettaglioLinee:
        this.settings = $scope.$parent.$resolve.settings;
        $scope.datiOrdineTooltip = $sce.trustAsHtml(
            'Questa sezione non è obbligatoria, ma potrebbe essere molto importante per il tuo cliente. Qui puoi inserire i dati di riferimento dell\'ordine inerente ai beni o ai servizi prestati. Questo aiuterà il destinatario ad integrare il ciclo passivo di fatturazione. ');
        $scope.String15Type = new RegExp('^[\u0000-\u007F]{1,15}$');
        $scope.String20Type = new RegExp('^[\u0000-\u007F]{1,20}$');
        let itemTemplate = {
            'TipoDocumento': '',
            'RiferimentoNumeroLinea': [],
            'IdDocumento': '',
            'Data': '',
            'NumItem': '',
            'CodiceCommessaConvenzione': '',
            'CodiceCUP': '',
            'CodiceCIG': ''
        };
        $scope.dettaglioLinee = this.settings.dettaglioLinee;
        $scope.items = [];
        let extractModalItems = (inputItems, label) => {
            if (inputItems === undefined) {
                return [];
            }
            let outputItems = [];
            for (let i = 0; i < inputItems.length; i++) {
                let item = jQuery.extend(true, {}, itemTemplate);
                item.TipoDocumento = label;

                for (let j = 0; j < this.settings.dettaglioLinee.length; j++) {
                    if (inputItems[i].RiferimentoNumeroLinea.indexOf(this.settings.dettaglioLinee[j].NumeroLinea * 1) !== -1) {
                        item.RiferimentoNumeroLinea.push(true);
                    } else {
                        item.RiferimentoNumeroLinea.push(false);
                    }
                }

                item.IdDocumento = inputItems[i].IdDocumento;
                item.Data = inputItems[i].Data;
                item.NumItem = inputItems[i].NumItem;
                item.CodiceCommessaConvenzione = inputItems[i].CodiceCommessaConvenzione;
                item.CodiceCIG = inputItems[i].CodiceCIG;
                item.CodiceCUP = inputItems[i].CodiceCUP;
                outputItems.push(item);
            }
            return outputItems;
        };
        let extractFatturaItems = () => {
            let DatiGenerali: any = {};
            DatiGenerali.DatiOrdineAcquisto = [];
            DatiGenerali.DatiContratto = [];
            DatiGenerali.DatiConvenzione = [];
            DatiGenerali.DatiRicezione = [];

            for (let i = 0; i < $scope.items.length; i++) {

                let newItem = jQuery.extend(true, {}, itemTemplate);

                delete newItem.TipoDocumento; // this property was add only for easier  management
                for (let j = 0; j < this.settings.dettaglioLinee.length; j++) {
                    if ($scope.items[i].RiferimentoNumeroLinea[j] === true) {
                        newItem.RiferimentoNumeroLinea.push(this.settings.dettaglioLinee[j].NumeroLinea * 1);
                    }
                }

                newItem.IdDocumento = $scope.items[i].IdDocumento;
                newItem.Data = $scope.items[i].Data;
                newItem.NumItem = $scope.items[i].NumItem;
                newItem.CodiceCommessaConvenzione = $scope.items[i].CodiceCommessaConvenzione;
                newItem.CodiceCUP = $scope.items[i].CodiceCUP;
                newItem.CodiceCIG = $scope.items[i].CodiceCIG;

                DatiGenerali[$scope.items[i].TipoDocumento].push(newItem);
            }

            return DatiGenerali;
        };
        $scope.items = $scope.items.concat(extractModalItems(this.settings.datiGenerali.DatiOrdineAcquisto, 'DatiOrdineAcquisto'));
        $scope.items = $scope.items.concat(extractModalItems(this.settings.datiGenerali.DatiContratto, 'DatiContratto'));
        $scope.items = $scope.items.concat(extractModalItems(this.settings.datiGenerali.DatiConvenzione, 'DatiConvenzione'));
        $scope.items = $scope.items.concat(extractModalItems(this.settings.datiGenerali.DatiRicezione, 'DatiRicezione'));
        $scope.addItem = () => {
            $scope.items.push(jQuery.extend(true, {}, itemTemplate));
        };
        $scope.removeItem = (index) => {
            let modalInstance = $uibModal.open({
                animation: $scope.animationsEnabled,
                component: 'defaultModalComponent',
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    config: () => {
                        return {
                            headerIcon: 'fa fa-exclamation-triangle',
                            headerText: 'Attenzione',
                            bodyHtml: '<i class=\'fa fa-exclamation-triangle\'></i> Sei sicuro di voler cancellare Dati Ordine?',
                            buttons: [
                                {
                                    'id': 1,
                                    'icon': 'fa fa-ban',
                                    'label': 'Annulla'
                                },
                                {
                                    'id': 2,
                                    'icon': 'fa fa-check-circle-o',
                                    'label': 'Si'
                                }
                            ]
                        };
                    }
                }
            });
            modalInstance.result.then((pressedButtonId) => {
                if (pressedButtonId !== undefined) {
                    if (pressedButtonId === 1) {
                        // ??
                    }
                    if (pressedButtonId === 2) {
                        $scope.items.splice(index, 1);
                    }
                }
            }, () => {
                // ?
            });
        };
        $scope.save = (errors) => {

            if ($.isEmptyObject(errors)) {
                let DatiGenerali = extractFatturaItems();
                this.close({ $value: DatiGenerali });
            } else {
                $rootScope.setErrorFieldsTouched(errors);
                $('[name=\'form\']').find('.ng-invalid:visible:first').focus();
            }
        };
        $scope.cancel = () => {
            this.close();
        };
    }
}

export const DatiOrdinePRModalComponent: ng.IComponentOptions = {
    template: require('./dati-ordine-pr-modal.html'),
    controller: DatiOrdinePRModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/dati-ordine-pr-modal/dati-ordine-pr-modal.ts